/* eslint react/no-unknown-property: 0 */
import React from 'react';

export function NeonIcon() {
  return (
    <svg
      width="56"
      height="17"
      viewBox="0 0 56 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_450_14644)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.3635C0 2.64649 0.286103 1.95884 0.79537 1.45184C1.30464 0.944835 1.99535 0.660004 2.71556 0.660004L13.0344 0.660004C13.7546 0.660004 14.4454 0.944835 14.9546 1.45184C15.4639 1.95884 15.75 2.64649 15.75 3.3635V12.1007C15.75 13.6452 13.7865 14.3155 12.8345 13.0964L9.85731 9.28357V13.907C9.85731 14.5523 9.59983 15.1711 9.14152 15.6274C8.6832 16.0837 8.06159 16.34 7.41344 16.34H2.71556C1.99535 16.34 1.30464 16.0552 0.79537 15.5482C0.286103 15.0412 0 14.3535 0 13.6365L0 3.3635ZM2.71556 2.82297C2.41544 2.82297 2.17263 3.06471 2.17263 3.36306V13.6365C2.17263 13.9353 2.41544 14.1775 2.71512 14.1775H7.49481C7.64488 14.1775 7.68469 14.0564 7.68469 13.907V7.70729C7.68469 6.16238 9.64819 5.49206 10.6006 6.71161L13.5778 10.524V3.3635C13.5778 3.06471 13.6058 2.82297 13.3061 2.82297H2.71556Z"
          fill="#12FFF7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.3635C0 2.64649 0.286103 1.95884 0.79537 1.45184C1.30464 0.944835 1.99535 0.660004 2.71556 0.660004L13.0344 0.660004C13.7546 0.660004 14.4454 0.944835 14.9546 1.45184C15.4639 1.95884 15.75 2.64649 15.75 3.3635V12.1007C15.75 13.6452 13.7865 14.3155 12.8345 13.0964L9.85731 9.28357V13.907C9.85731 14.5523 9.59983 15.1711 9.14152 15.6274C8.6832 16.0837 8.06159 16.34 7.41344 16.34H2.71556C1.99535 16.34 1.30464 16.0552 0.79537 15.5482C0.286103 15.0412 0 14.3535 0 13.6365L0 3.3635ZM2.71556 2.82297C2.41544 2.82297 2.17263 3.06471 2.17263 3.36306V13.6365C2.17263 13.9353 2.41544 14.1775 2.71512 14.1775H7.49481C7.64488 14.1775 7.68469 14.0564 7.68469 13.907V7.70729C7.68469 6.16238 9.64819 5.49206 10.6006 6.71161L13.5778 10.524V3.3635C13.5778 3.06471 13.6058 2.82297 13.3061 2.82297H2.71556Z"
          fill="url(#paint0_linear_450_14644)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.3635C0 2.64649 0.286103 1.95884 0.79537 1.45184C1.30464 0.944835 1.99535 0.660004 2.71556 0.660004L13.0344 0.660004C13.7546 0.660004 14.4454 0.944835 14.9546 1.45184C15.4639 1.95884 15.75 2.64649 15.75 3.3635V12.1007C15.75 13.6452 13.7865 14.3155 12.8345 13.0964L9.85731 9.28357V13.907C9.85731 14.5523 9.59983 15.1711 9.14152 15.6274C8.6832 16.0837 8.06159 16.34 7.41344 16.34H2.71556C1.99535 16.34 1.30464 16.0552 0.79537 15.5482C0.286103 15.0412 0 14.3535 0 13.6365L0 3.3635ZM2.71556 2.82297C2.41544 2.82297 2.17263 3.06471 2.17263 3.36306V13.6365C2.17263 13.9353 2.41544 14.1775 2.71512 14.1775H7.49481C7.64488 14.1775 7.68469 14.0564 7.68469 13.907V7.70729C7.68469 6.16238 9.64819 5.49206 10.6006 6.71161L13.5778 10.524V3.3635C13.5778 3.06471 13.6058 2.82297 13.3061 2.82297H2.71556Z"
          fill="url(#paint1_linear_450_14644)"
        />
        <path
          d="M13.0346 0.660004C13.7548 0.660004 14.4455 0.944835 14.9548 1.45184C15.464 1.95884 15.7501 2.64649 15.7501 3.3635V12.1007C15.7501 13.6452 13.7866 14.3155 12.8346 13.0964L9.85745 9.28357V13.907C9.85745 14.5523 9.59997 15.1711 9.14166 15.6274C8.68334 16.0837 8.06173 16.34 7.41357 16.34C7.4492 16.34 7.48447 16.333 7.51738 16.3195C7.55029 16.3059 7.58019 16.286 7.60538 16.2609C7.63056 16.2358 7.65055 16.2061 7.66418 16.1733C7.67781 16.1405 7.68482 16.1054 7.68482 16.07V7.70729C7.68482 6.16238 9.64833 5.49206 10.6008 6.71161L13.578 10.524V1.20053C13.578 0.902173 13.3347 0.660004 13.0346 0.660004Z"
          fill="#B9FFB3"
        />
        <path
          d="M26.5499 5.27689V9.37809L22.5556 5.27689H20.4766V11.9845H22.3727V7.57663L26.7232 11.9845H28.4461V5.27689H26.5499V5.27689ZM31.9609 10.4896V9.30143H36.2056V7.87368H31.9609V6.77172H37.1103V5.27689H30.0263V11.9845H37.2162V10.4896H31.9609ZM42.2549 12.2048C44.921 12.2048 46.6535 10.9017 46.6535 8.63067C46.6535 6.35969 44.921 5.0565 42.2549 5.0565C39.5887 5.0565 37.8659 6.35969 37.8659 8.63067C37.8659 10.9017 39.5887 12.2048 42.2549 12.2048ZM42.2549 10.6142C40.7726 10.6142 39.8582 9.89553 39.8582 8.63067C39.8582 7.36582 40.7822 6.64715 42.2549 6.64715C43.7371 6.64715 44.6515 7.36582 44.6515 8.63067C44.6515 9.89553 43.7371 10.6142 42.2549 10.6142ZM53.9212 5.27689V9.37809L49.9269 5.27689H47.8479V11.9845H49.744V7.57663L54.0945 11.9845H55.8174V5.27689H53.9212Z"
          fill="black"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_450_14644"
          x1="15.75"
          y1="16.34"
          x2="1.97047"
          y2="0.599132"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9FFB3" />
          <stop offset="1" stopColor="#B9FFB3" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_450_14644"
          x1="15.75"
          y1="16.34"
          x2="6.40592"
          y2="12.6894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1A1A" stopOpacity="0.9" />
          <stop offset="1" stopColor="#1A1A1A" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_450_14644">
          <rect
            width="56"
            height="15.68"
            fill="white"
            transform="translate(0 0.660004)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
